export function formatNumber(number) {
  if (number == null ) {
    return "";
  } else {
    let val = parseFloat(number);
    return parseFloat(val.toFixed(2));
  }

}